import { keyframes } from "styled-components";

export const translateUpImage1 = keyframes({
  "0%": { transform: "translateY(0)" },
  "100%": { transform: "translateY(-50%)" },
});

export const translateUpImage2 = keyframes({
  "0%": { transform: "translateY(50%)" },
  "100%": { transform: "translateY(0)" },
});

export const translateDownImage1 = keyframes({
  "0%": { transform: "translateY(0)" },
  "100%": { transform: "translateY(50%)" },
});

export const translateDownImage2 = keyframes({
  "0%": { transform: "translateY(-50%)" },
  "100%": { transform: "translateY(0)" },
});

export const translateRightImage1 = keyframes({
  "0%": { transform: "translateX(0)" },
  "100%": { transform: "translateX(-50%)" },
});

export const translateRightImage2 = keyframes({
  "0%": { transform: "translateX(50%)" },
  "100%": { transform: "translateX(0)" },
});

export const translateLeftImage1 = keyframes({
  "0%": { transform: "translateX(0)" },
  "100%": { transform: "translateX(50%)" },
});

export const translateLeftImage2 = keyframes({
  "0%": { transform: "translateX(-50%)" },
  "100%": { transform: "translateX(0)" },
});

export const fadeOut = keyframes({
  "0%": { opacity: "1" },
  "100%": { opacity: "0" },
});

export const fadeIn = keyframes({
  "0%": { opacity: "0" },
  "100%": { opacity: "1" },
});
